import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 80px);

  ${Media.Phone`
    height: calc(100vh - 150px);
  `};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 64px;
  gap: 64px;
  width: 100%;
  overflow: auto;

  ${Media.Phone`
    gap: 48px;
    padding: 20px;
    padding-bottom: 0;
  `};
`

export const BoxWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;

  ${Media.Phone`
    align-items: center;
    flex-direction: column;
    gap: 20px;
  `};
`

export const Box = styled.div<{ $isError?: boolean }>`
  max-width: 448px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;

  border: 1px solid ${({ $isError }) => ($isError ? Colors.Red50 : Colors.Neutral15)};
  border-radius: 16px;
  gap: 12px;
  cursor: pointer;

  ${Media.Tablet`
    max-width: 448px;
    height: unset;
  `}

  ${Media.Phone`
    height: 216px;
    width: 100%;
  `}

  &:hover {
    box-shadow: 0px 16px 64px -8px rgba(15, 56, 113, 0.18), 0px 6px 8px -2px rgba(15, 56, 113, 0.02),
      0px 0px 1px 0px rgba(15, 56, 113, 0.32);
    transition: box-shadow 0.2s ease-in;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const Image = styled.div<{ $image: string }>`
  width: 100%;
  height: 228px;
  background-image: ${({ $image }) => `url(${$image})`};
  background-size: contain;
  background-position: center;

  ${Media.Phone`
    height: 100px;
    background-size: contain;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  padding: 0 32px 32px;

  ${Media.Phone`
    padding: 0 24px 24px;
  `}
`

export const Header = styled.h2<{ $isTrCard?: boolean }>`
  ${Typography.S}
  ${FontWeights.Medium}

  text-align: center;
  color: ${Colors.Neutral90};
  max-width: ${({ $isTrCard }) => ($isTrCard ? '385px' : '250px')};
`

export const Description = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  max-width: 250px;
  text-align: center;
  color: ${Colors.Neutral50};
`

export const UploadFromDevice = styled.label`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
`

export const ErrorContainer = styled.div`
  height: 40px;
  bottom: -52px;
  position: absolute;
  display: flex;

  ${Media.Phone`
    bottom: -50px;
  `}
`

export const ErrorLabel = styled.p`
  ${Typography.Caption}
  ${FontWeights.Regular}

  text-align: center;
  color: ${Colors.Red50};
`
const BADGE_HEIGHT = 38
export const Badge = styled.div`
  position: absolute;
  height: ${BADGE_HEIGHT}px;
  top: -${BADGE_HEIGHT / 2}px;
  display: flex;
  padding: ${Spacing['2XS']} 10px;
  align-items: center;
  gap: 6px;
  border-radius: ${Spacing['3XS']};
  border: 1px solid ${Colors.Blue50};
  color: ${Colors.Blue50};

  background: ${Colors.Blue10};

  ${Typography.Caption}
  ${FontWeights.Medium}
`

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 448px;
  justify-content: space-between;
`
